import Input from "../../atoms/Input/Input";
import { useFormContext } from "react-hook-form";
import FileInput from "../../atoms/FileInput/FileInput";

const AboutBannerSection = () => {
  const {
    formState: { errors },
    register,
    control,
    getValues,
  } = useFormContext();

  return (
    <div className="flex-column gap-20">
      <FileInput
        label="Banner Image*"
        register={register}
        registerName="aboutUsBannerImage"
        disabled={false}
        accept="image/png,image/jpeg,image/jpg,image/svg+xml"
        control={control}
        errorMessage={errors?.aboutUsBannerImage?.message}
        value={getValues("aboutUsBannerImage") ?? ""}
      />
      <Input
        type="text"
        placeholder="Title"
        label="Title*"
        register={register}
        registerName="aboutUsBannerTitle"
        errorMessage={errors?.aboutUsBannerTitle?.message}
      />
      <Input
        type="textarea"
        label="Description*"
        placeholder="Description"
        register={register}
        registerName="aboutUsBannerDescription"
        errorMessage={errors?.aboutUsBannerDescription?.message}
      />
    </div>
  );
};

export default AboutBannerSection;
